import React, { useState, useContext, useEffect } from "react";
import { Link as RouterLink } from "react-router-dom";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import { i18n } from "../../translate/i18n";
import { AuthContext } from "../../context/Auth/AuthContext";
import ColorModeContext from "../../layout/themeContext";
import useSettings from "../../hooks/useSettings";
import IconButton from "@material-ui/core/IconButton";
import { Helmet } from "react-helmet";
import { useTheme } from "@material-ui/core/styles";
import { InputAdornment } from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import BRFlag from "../../assets/brazil.png";
import USFlag from "../../assets/unitedstates.png";
import ESFlag from "../../assets/esspain.png";

const languageOptions = [
  { value: "pt-BR", label: "Português", icon: BRFlag },
  { value: "en", label: "English", icon: USFlag },
  { value: "es", label: "Spanish", icon: ESFlag },
];

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100vw",
    height: "100vh",
    background:
      theme.mode === "light" ? theme.palette.light : theme.palette.light,
    backgroundRepeat: "no-repeat",
    backgroundImage: `url('/banner-one.jpg')`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    [theme.breakpoints.down("md")]: {
      left: "200px",
      padding: "45px 25px",
    },
    [theme.breakpoints.down("sm")]: {
      left: "50px",
      padding: "35px 20px",
    },
    [theme.breakpoints.down("xs")]: {
      left: "0",
      padding: "25px 15px",
      alignItems: "center",
    },
  },
  paper: {
    backgroundColor:
      theme.mode === "light"
        ? "rgba(255, 255, 255, 0.67)"
        : "rgba(255, 255, 255, 0.62)",
    backdropFilter: "blur(10px)",
    boxShadow:
      theme.mode === "light"
        ? "0 4px 6px rgba(0, 0, 0, 0.61)"
        : "0 4px 6px rgba(255, 255, 255, 0.62)",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start", // Alterado para alinhar os itens à esquerda
    padding: "3px 30px",
    borderRadius: "30px",
    borderRight:
      theme.mode === "light"
        ? "1px solid rgba(0, 0, 0, 0.61)"
        : "1px solid rgba(255, 255, 255, 0.62)",
    position: "relative", // Adicionado, se for necessário um ajuste de posição*/
    left: "460px", // Opcional: se você quiser ajustar mais para a esquerda
    [theme.breakpoints.down("md")]: {
      left: "500px",
      padding: "45px 25px",
    },
    [theme.breakpoints.down("sm")]: {
      left: "50px",
      padding: "35px 20px",
    },
    [theme.breakpoints.down("xs")]: {
      left: "0",
      padding: "25px 15px",
      alignItems: "center",
    },
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.primary.main,
  },
  form: {
    width: "100%",
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  powered: {
    color: "white",
  },
  logoImg: {
    width: "100%",
    maxWidth: "350px",
    height: "auto",
    maxHeight: "120px",
    margin: "0 auto",
    content:
      "url(" +
      (theme.mode === "light"
        ? theme.calculatedLogoLight()
        : theme.calculatedLogoDark()) +
      ")",
  },
  input: {
    width: "100%",
    marginBottom: "15px", // Espaçamento entre inputs
  },
  recaptcha: {
    width: "100%",
    display: "flex",
    justifyContent: "center", // Centraliza o reCAPTCHA
    marginTop: "10px", // Dá um espaço entre os inputs e o reCAPTCHA
    opacity: 0.7, // Diminui a opacidade do reCAPTCHA
  },
  iconButton: {
    position: "absolute",
    top: 10,
    right: 10,
    color: theme.mode === "light" ? "black" : "#555",
  },
}));

const Login = () => {
  const classes = useStyles();
  const { colorMode } = useContext(ColorModeContext);
  const { appLogoFavicon, appName, mode } = colorMode;
  const [user, setUser] = useState({ email: "", password: "" });
  const [allowSignup, setAllowSignup] = useState(false);
  const { getPublicSetting } = useSettings();
  const { handleLogin } = useContext(AuthContext);
  const [showPassword, setShowPassword] = useState(false);
  const [open, setOpen] = useState(false);

  const handleChangeInput = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handlSubmit = (e) => {
    e.preventDefault();
    handleLogin(user);
  };

  const current =
    languageOptions.find((opt) => opt.value === i18n.language) ||
    languageOptions[0];

  const handleSelect = (opt) => {
    i18n.changeLanguage(opt.value);
    localStorage.setItem("language", opt.value);
    setOpen(false);
    window.location.reload();
  };

  useEffect(() => {
    getPublicSetting("allowSignup")
      .then((data) => {
        setAllowSignup(data === "enabled");
      })
      .catch((error) => {
        console.log("Error reading setting", error);
      });
  }, []);

  return (
    <>
      <Helmet>
        <title>{appName || "Automatize"}</title>
        <link rel="icon" href={appLogoFavicon || "/default-favicon.ico"} />
      </Helmet>
      <div className={classes.root}>
        <Container component="main" maxWidth="xs">
          <CssBaseline />
          <div className={classes.paper}>
            {/* <IconButton className={classes.iconButton} onClick={colorMode.toggleColorMode}>
							{mode === "dark" ? <Brightness7Icon /> : <Brightness4Icon />}
						</IconButton> */}
            <div>
              <img className={classes.logoImg} alt="logo" />
            </div>
            <form className={classes.form} noValidate onSubmit={handlSubmit}>
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="email"
                label={i18n.t("login.form.email")}
                name="email"
                value={user.email}
                onChange={handleChangeInput}
                autoComplete="email"
                autoFocus
              />
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                name="password"
                label={i18n.t("login.form.password")}
                type={showPassword ? "text" : "password"}
                id="password"
                value={user.password}
                onChange={handleChangeInput}
                autoComplete="current-password"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: "15px" }}>
                <div style={{ position: "relative" }}>
                  <button
                    type="button"
                    onClick={() => setOpen((o) => !o)}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      padding: 0,
                    }}
                  >
                    <img
                      src={current.icon}
                      alt={current.label}
                      style={{ width: 24, height: 24 }}
                    />
                  </button>

                  {open && (
                    <ul
                      style={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        margin: 0,
                        padding: "4px 0",
                        listStyle: "none",
                        background: "#fff",
                        border: "1px solid #ccc",
                        boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                        zIndex: 1000,
                        width: "auto",
                      }}
                    >
                      {languageOptions.map((opt) => (
                        <li
                          key={opt.value}
                          onClick={() => handleSelect(opt)}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            padding: "6px 12px",
                            cursor: "pointer",
                            borderBottom: "1px solid #eee",
                          }}
                        >
                          <img
                            src={opt.icon}
                            alt={opt.label}
                            style={{ width: 20, marginRight: 8 }}
                          />
                          {opt.label}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>

              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
              >
                {i18n.t("login.buttons.submit")}
              </Button>
              {allowSignup && (
                <Grid container>
                  <Grid item>
                    <Link
                      href="#"
                      variant="body2"
                      component={RouterLink}
                      to="/signup"
                    >
                      {i18n.t("login.buttons.register")}
                    </Link>
                  </Grid>
                </Grid>
              )}
            </form>
          </div>
        </Container>
      </div>
    </>
  );
};

export default Login;
